import type { NewsLogo } from "./news-types";

import { cn } from "@homeinstead/ui";

/**
 * @deprecated Use an FeaturedNewsLogo from `@homeinstead/ui/components/FeaturedNewsLogos` instead
 */
export const FeaturedNewsLogo = ({ Icon, width, className }: NewsLogo) => {
  return (
    <div className={cn("relative shrink-0", width)}>
      <Icon className={className} />
    </div>
  );
};
